<script lang="ts">
    import { tooltip } from "$/utils/tooltip";
    import { TopicAccessLevel } from "$/stores/extension/ActiveTopicStore";
    import { ServiceConsts } from "$/services/ServiceConsts";

    export let mention;
    export let disabled = false;
    export let showUpgradeCTA = false;
    export let mentionOnly = false;
</script>

<div class="collaborator-email">{mention.user.username}</div>

{#if mentionOnly}
    <div
        class="collaborator-role-picker-mention-only input-disabled"
        use:tooltip={"Shares just this snippet & your comment, not the full topic."}
    >
        Mention only
    </div>
{:else}
    <select
        class="collaborator-role-picker"
        class:input-disabled={disabled}
        bind:value={mention.topicRole.role}
        {disabled}
        use:tooltip={mention.topicRole.role === TopicAccessLevel.VIEWER
            ? "Can view everything in this topic."
            : mention.topicRole.role === TopicAccessLevel.COMMENTER
              ? "Can view and comment on anything in this topic."
              : mention.topicRole.role === TopicAccessLevel.EDITOR
                ? "Can fully edit, add, or remove anything in this topic."
                : mention.topicRole.role === TopicAccessLevel.MENTION
                  ? "Shares just this snippet & your comment, not the full topic."
                  : ""}
    >
        <option value={TopicAccessLevel.VIEWER}>Viewer</option>
        <option value={TopicAccessLevel.COMMENTER}>Commenter</option>
        <option value={TopicAccessLevel.EDITOR}>Editor</option>
        <option value={TopicAccessLevel.MENTION}>Mention only</option>
    </select>
{/if}

{#if showUpgradeCTA}
    <a
        class="upgrade-icon"
        href={`${ServiceConsts.DASHBOARD_URL}/payment`}
        target="_blank"
        use:tooltip={"Upgrade to add more Collaborators"}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="size-4"
        >
            <path
                fill-rule="evenodd"
                d="M9.58 1.077a.75.75 0 0 1 .405.82L9.165 6h4.085a.75.75 0 0 1 .567 1.241l-6.5 7.5a.75.75 0 0 1-1.302-.638L6.835 10H2.75a.75.75 0 0 1-.567-1.241l6.5-7.5a.75.75 0 0 1 .897-.182Z"
                clip-rule="evenodd"
            />
        </svg>
    </a>
{/if}

<style>
    .collaborator-email {
        @apply overflow-hidden text-ellipsis whitespace-nowrap text-black;
    }

    .collaborator-role-picker {
        @apply reset ml-auto min-w-fit cursor-pointer appearance-auto bg-white text-right text-xs outline-none !important;
    }

    .collaborator-role-picker-mention-only {
        @apply reset ml-1 min-w-fit appearance-auto self-center bg-white text-right text-xs outline-none !important;
    }

    .input-disabled {
        @apply appearance-none text-gray-300 !important;
    }

    .mention-info-tooltip {
        @apply ml-auto h-4 w-4 self-center text-gray-700;
    }

    .mention-info-tooltip--disabled {
        @apply text-gray-300;
    }

    .upgrade-icon {
        @apply ml-2 flex items-center justify-center rounded-sm bg-yellow-200 p-1 text-black hover:rotate-1 hover:scale-110 hover:bg-yellow-400;
    }

    .upgrade-icon svg {
        @apply h-3 w-3 min-w-3;
    }
</style>
